import {
  TrendingUp,
  BarChart3,
  Zap,
  MessageSquare,
  Users,
  Brain,
  FileText,
  GitBranch,
  Palette,
  ShoppingCart,
  FileCheck,
  Ruler,
  Upload,
  PieChart,
  Building,
  Coins,
  Layers,
  type LucideIcon,
} from "lucide-react";
import type { FeatureKey } from "@/hooks/useTenantPlan";

export interface FeatureInfo {
  key: FeatureKey;
  label: string;
  icon: LucideIcon;
}

export const FEATURE_CATALOG: FeatureInfo[] = [
  { key: "crm", label: "CRM", icon: TrendingUp },
  { key: "atividades", label: "Atividades e Tarefas", icon: FileText },
  { key: "calculadora_simplificada", label: "Calculadora Solar", icon: Ruler },
  { key: "calculadora_avancada", label: "Calculadora Avançada", icon: Ruler },
  { key: "financeiro", label: "Financeiro", icon: BarChart3 },
  { key: "instalacoes", label: "Instalações", icon: Zap },
  { key: "relatorios", label: "Relatórios", icon: FileText },
  { key: "ai_insights", label: "AI Insights", icon: Brain },
  { key: "contratos", label: "Contratos", icon: FileCheck },
  { key: "auto_proposta", label: "Propostas Auto.", icon: ShoppingCart },
  { key: "dimensionamento", label: "Dimensionamento", icon: Ruler },
  { key: "importacao_csv", label: "Importação CSV", icon: Upload },
  { key: "sales_page", label: "Página de Vendas", icon: Building },
  { key: "suprimentos", label: "Suprimentos/Compras", icon: ShoppingCart },
  { key: "engenharia", label: "Engenharia", icon: Ruler },
  { key: "logistica", label: "Logística", icon: Layers },
  { key: "dossie", label: "Dossiê de Conclusão", icon: FileCheck },
  { key: "whatsapp", label: "WhatsApp", icon: MessageSquare },
  { key: "portal_cliente", label: "Portal do Cliente", icon: Users },
  { key: "dre", label: "DRE Gerencial", icon: PieChart },
  { key: "relatorios_avancados", label: "Relatórios Avançados", icon: BarChart3 },
  { key: "conciliacao_bancaria", label: "Conciliação Bancária", icon: Coins },
  { key: "comissoes", label: "Comissões", icon: Coins },
  { key: "permissoes_secoes", label: "Permissões de Seções", icon: Users },
  { key: "visibilidade_documentos", label: "Visibilidade de Documentos", icon: FileText },
  { key: "api_access", label: "API & Integrações", icon: GitBranch },
  { key: "white_label", label: "White Label", icon: Palette },
  { key: "multi_pipeline", label: "Multi Pipeline", icon: Layers },
];

export const PLAN_COLORS: Record<string, { badge: string; gradient: string; ring: string }> = {
  Free: {
    badge: "bg-muted text-muted-foreground",
    gradient: "from-muted/50 to-muted/20",
    ring: "ring-muted-foreground/30",
  },
  Starter: {
    badge: "bg-blue-500 text-white",
    gradient: "from-blue-500/10 to-blue-500/5",
    ring: "ring-blue-500/30",
  },
  Trial: {
    badge: "bg-amber-500 text-white",
    gradient: "from-amber-500/10 to-amber-500/5",
    ring: "ring-amber-500/30",
  },
  Profissional: {
    badge: "bg-emerald-600 text-white",
    gradient: "from-emerald-600/10 to-emerald-600/5",
    ring: "ring-emerald-600/30",
  },
  Business: {
    badge: "bg-indigo-600 text-white",
    gradient: "from-indigo-600/10 to-indigo-600/5",
    ring: "ring-indigo-600/30",
  },
  Enterprise: {
    badge: "bg-violet-600 text-white",
    gradient: "from-violet-600/10 to-violet-600/5",
    ring: "ring-violet-600/30",
  },
  // Legacy aliases
  Pro: {
    badge: "bg-emerald-600 text-white",
    gradient: "from-emerald-600/10 to-emerald-600/5",
    ring: "ring-emerald-600/30",
  },
};

/** @deprecated Use usePlanCatalog().getMinPlanForFeature() instead */
export function getFeatureMinPlan(_featureKey: FeatureKey): string | undefined {
  return undefined;
}

export function getPlanColor(planName: string | null): typeof PLAN_COLORS["Free"] {
  if (!planName) return PLAN_COLORS.Free;
  const normalized = Object.keys(PLAN_COLORS).find(
    (k) => k.toLowerCase() === planName.toLowerCase()
  );
  return PLAN_COLORS[normalized ?? "Free"] ?? PLAN_COLORS.Free;
}
